import React, { memo, useEffect, useRef } from "react";
import { Checkbox, FormControl, FormControlLabel, Grid } from "@mui/material";
import {
	flexCenterProps,
	horizontalFormControlGridRightStyle,
	paddingX1Props,
} from "@styles/global-css-class";
import { ICheckboxFormControlProperty } from "@definitions/index";
import { FieldError } from "@components/FieldError";
import DiffInheritanceIndicator from "@components/DiffInheritanceIndicator";

function NewCheckboxFormControl({
	childKey,
	label,
	labelPlacement,
	value,
	name,
	defaultValue,
	placeHolder,
	isRequired,
	isDisabled,
	isHidden = false,
	onChange,
	formState,
	xsFormControl = 12,
	mdFormControl = 12,
	textAlign,
	textErrorAlign,
	itemSx,
	textSx,
	isShowCheckboxLabel = true,
	checkBoxSx,
	isExpanded,
	isHideLabel,
	isShowRequiredAsterisk,
	showIndicator,
	isIndicatorTakeSpace,
	errorName,
	...props
}: Readonly<ICheckboxFormControlProperty>) {
	const inputRef = useRef<HTMLInputElement>(null);
	useEffect(() => {
		if (isExpanded && inputRef.current) {
			inputRef.current?.focus();
		}
	}, [isExpanded, inputRef.current])

	return <Grid container item xs={xsFormControl} md={mdFormControl} sx={itemSx ?? {
		...paddingX1Props,
		py: "13px",
		alignContent: 'center'
	}}>
		<FormControl key={`${childKey}-form-control`} fullWidth margin='dense' {...props}>
			<Grid container flexWrap={'nowrap'} alignItems='center' justifyContent={textAlign ?? 'flex-start'}>
				<Grid item sx={checkBoxSx ?? itemSx ?? horizontalFormControlGridRightStyle} >
					<FormControlLabel
						key={`${childKey}-form-control-label`}
						labelPlacement={labelPlacement}
						control={
							<Checkbox
								id={name}
								name={name}
								key={`${childKey}-form-control-${name}`}
								checked={value ?? defaultValue ?? false}
								onChange={(e) => {
									onChange(e.target.checked);
								}}
								inputRef={inputRef}
								hidden={isHidden}
								disabled={isDisabled ?? false}
								color={formState?.errors[errorName ?? name] !== undefined ? "error" : "default"}
								size="small"
								value={isShowCheckboxLabel && label} />
						}
						label={!isHideLabel && `${label} ${isRequired && isShowRequiredAsterisk ? '*' : ''}`}
						sx={textSx ?? undefined}
					/>
				</Grid>
				{
					showIndicator !== undefined && showIndicator() == true
					&&
					<Grid xs={isIndicatorTakeSpace ? 1 : 0} item >
						<DiffInheritanceIndicator />
					</Grid>
				}
			</Grid>

			{formState && <FieldError key={`${childKey}-form-control-error`} formState={formState} name={errorName ?? name} textAlign={textErrorAlign} />}
		</FormControl>
	</Grid >
}

export default memo(NewCheckboxFormControl);
